// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"100":"password-recovery","727":"login-widget","966":"login"}[chunkId] + "." + {"100":"2c6e529e","727":"1871b2bc","966":"1871b2bc"}[chunkId] + ".chunk.css";
};